import { render, staticRenderFns } from "./SupervisorNav.vue?vue&type=template&id=4b2e3354&scoped=true&"
import script from "./SupervisorNav.vue?vue&type=script&lang=js&"
export * from "./SupervisorNav.vue?vue&type=script&lang=js&"
import style0 from "./SupervisorNav.vue?vue&type=style&index=0&id=4b2e3354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2e3354",
  null
  
)

export default component.exports